import Vue from 'vue';

import {
  SEND_WEBSOCKET_MESSAGE,
  UPDATE_WEB_SOCKET_STATUS,
  WEBSOCKET_EVENT_HANDLE_MESSAGE,
} from '../store/websocket/actions/actionTypes';

import { acquireToken } from '../services/auth';
import onlineService from '../services/onlineService';

let _reconnectTimer = null;
const RECONNECT_DELAY_MS = 2000;

async function _scheduleReconnect() {
  if (_reconnectTimer) return;

  _reconnectTimer = setTimeout(async () => {
    _reconnectTimer = null;

    const isOnline = await onlineService.canConnectRealtime();
    if (!isOnline) {
      return;
    }

    const socket = Vue.prototype.$socket;
    const isOpenOrConnecting =
      socket &&
      (socket.readyState === WebSocket.OPEN ||
        socket.readyState === WebSocket.CONNECTING);

    if (isOpenOrConnecting) return;

    if (typeof Vue.prototype.$connect === 'function') {
      Vue.prototype.$connect();
    }
  }, RECONNECT_DELAY_MS);
}

const websocketService = {
  sendMessage(message) {
    if (Vue.prototype.$socket && Vue.prototype.$socket.sendObj) {
      Vue.prototype.$socket.sendObj(message);
    } else {
      console.error('WebSocket connection is not established.');
    }
  },

  sendRawMessage(message) {
    if (Vue.prototype.$socket && Vue.prototype.$socket.send) {
      Vue.prototype.$socket.send(message);
    } else {
      console.error('WebSocket connection is not established.');
    }
  },

  closeConnection() {
    if (Vue.prototype.$socket) {
      Vue.prototype.$socket.close();
    } else {
      console.error('WebSocket connection is not established.');
    }
  },

  async onOpen() {
    console.log('WebSocket connection opened');

    if (_reconnectTimer) {
      clearTimeout(_reconnectTimer);
      _reconnectTimer = null;
    }

    try {
      const token = await acquireToken();

      this.$store.dispatch(SEND_WEBSOCKET_MESSAGE, {
        action: 'registerToken',
        data: token,
      });
      console.log('WebSocket registration');
    } catch (error) {
      console.log('WebSocket registration after log in...');
    }
  },

  onClose() {
    console.log('WebSocket connection closed');
    this.$store.dispatch(UPDATE_WEB_SOCKET_STATUS, 'Disconnected');
    _scheduleReconnect();
  },
  onError(error) {
    console.error('WebSocket error:', error);
    this.$store.dispatch(UPDATE_WEB_SOCKET_STATUS, 'Error');
  },
  onMessage(message) {
    const { data } = message;

    // We make sure to parse only json messages
    try {
      const parsedMessage = JSON.parse(data);

      if (parsedMessage.action) {
        console.log('Managing event', parsedMessage.action);

        this.$store.dispatch(WEBSOCKET_EVENT_HANDLE_MESSAGE, parsedMessage);
      }
      // eslint-disable-next-line no-empty
    } catch (error) {
      console.log(`Received websocket message ${data}`);
    }
  },
};

export default websocketService;
